import { motion } from "framer-motion";

export const About = () => (
  <section id="about" className="py-20 lg:py-32 bg-white border-y border-border scroll-mt-20">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="lg:col-span-5 relative self-start lg:sticky lg:top-28"
      >
        <div className="absolute -bottom-4 -left-4 w-full h-full border border-forest/30 rounded-2xl" aria-hidden="true" />
        <img
          src="https://images.pexels.com/photos/7580763/pexels-photo-7580763.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Rajkiran, founder and personal finance advisor"
          loading="lazy"
          data-testid="about-advisor-image"
          className="relative rounded-2xl object-cover w-full max-h-[60vh] lg:h-[560px]"
        />
        <div className="relative mt-6 bg-forest text-bone rounded-xl px-6 py-5">
          <p className="font-serif text-xl lg:text-2xl font-medium leading-snug" data-testid="about-tagline">
            35 Years of Experience. One Commitment: Your Wealth, Your Future.
          </p>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.15 }}
        className="lg:col-span-7"
      >
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-bronze">About us</p>
        <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-forest">
          A journey shaped by 35 years of trust
        </h2>

        <p className="mt-8 text-base text-muted-foreground leading-relaxed">
          <span className="float-left mr-3 font-serif text-6xl lg:text-7xl leading-[0.8] text-bronze">R</span>
          ajkiran Wealth is built on over 35 years of experience, trust, and understanding of the
          financial markets. From navigating market highs and lows to adapting to changing economic
          cycles, our journey has been shaped by decades of hands-on experience and a deep
          understanding of wealth and markets.
        </p>

        <p className="mt-6 text-base text-muted-foreground leading-relaxed">
          Our journey began in Assam, where we established our foundation by building strong
          relationships and serving clients with integrity and commitment. Over the years, we
          expanded our presence beyond Assam, establishing our roots and reach across Delhi and
          other parts of India.
        </p>

        <p className="mt-6 text-base text-muted-foreground leading-relaxed">
          At Rajkiran Wealth, we believe that wealth management is not simply about numbers or
          market movements—it is about understanding people, their goals, and their aspirations.
          Our approach is built around long-term relationships, informed decision-making, and
          disciplined wealth creation.
        </p>

        <p className="mt-6 text-base text-muted-foreground leading-relaxed">
          With decades of experience through different market cycles, we bring a perspective that
          combines traditional values with a modern approach to wealth management. Whether it is
          preserving wealth, creating long-term growth, or planning for the future, our aim is to
          provide thoughtful and personalised solutions for every client.
        </p>

        <blockquote className="mt-8 border-l-2 border-bronze pl-6 font-serif text-xl lg:text-2xl text-forest leading-relaxed">
          From our roots in Assam to our growing presence across India, Rajkiran Wealth continues
          to be guided by the same principles that have shaped our journey for 35 years—trust,
          experience, integrity, and long-term relationships.
        </blockquote>
      </motion.div>
    </div>
  </section>
);
